import dayjs from "dayjs";
import urlon from "urlon";

const cleaners = [
  {
    testObj: (value) => value instanceof Date,
    testValue: (value) =>
      value && typeof value === "object" && "__date__" in value,
    clean: (value) => ({ __date__: dayjs(value).format("YYYY-MM-DD") }),
    parse: (value) => dayjs(value.__date__).toDate(),
  },
  {
    testObj: (value) => dayjs.isDayjs(value),
    testValue: (value) =>
      value && typeof value === "object" && "__dayjs__" in value,
    clean: (value) => ({ __dayjs__: value.format("YYYY-MM-DD") }),
    parse: (value) => dayjs(value.__dayjs__),
  },
];

function clean(obj) {
  const cleaner = cleaners.find((c) => c.testObj(obj));
  if (cleaner) {
    return cleaner.clean(obj);
  }
  if (Array.isArray(obj)) {
    return obj.map(clean);
  }
  if (obj && typeof obj === "object") {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [key, clean(value)]),
    );
  }
  return obj;
}

function toObject(value) {
  const cleaner = cleaners.find((c) => c.testValue(value));
  if (cleaner) {
    return cleaner.parse(value);
  }
  if (Array.isArray(value)) {
    return value.map(toObject);
  }
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, val]) => [key, toObject(val)]),
    );
  }
  return value;
}

const stringify = (value) => {
  return urlon.stringify(clean(value));
};

const parse = (queryString) => {
  return toObject(urlon.parse(queryString));
};

const customUrlon = {
  stringify,
  parse,
};

export default customUrlon;
